import type { Template } from "@/types";

export const PO_04_H0_V4: Template[] = [
    {
        id: "po-04-h0v4-01",
        name: "PO 01 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 36, y: 188, width: 290, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 333, y: 188, width: 290, height: 408, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 188, width: 290, height: 408, rotation: 0, imageRotation: 0 },
            { id: "4", x: 927, y: 188, width: 290, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-02",
        name: "PO 02 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 176, width: 308, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 315, y: 176, width: 308, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 631, y: 176, width: 308, height: 433, rotation: 0, imageRotation: 0 },
            { id: "4", x: 946, y: 176, width: 307, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-03",
        name: "PO 03 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 32, y: 196, width: 278, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 196, width: 278, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 658, y: 196, width: 278, height: 391, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 196, width: 278, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-04",
        name: "PO 04 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 37, y: 158, width: 332, height: 466, rotation: 0, imageRotation: 0 },
            { id: "2", x: 377, y: 240, width: 215, height: 303, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 240, width: 215, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 883, y: 158, width: 332, height: 466, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-05",
        name: "PO 05 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 29, y: 129, width: 376, height: 524, rotation: 0, imageRotation: 0 },
            { id: "2", x: 413, y: 129, width: 184, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 413, y: 395, width: 184, height: 258, rotation: 0, imageRotation: 0 },
            { id: "4", x: 753, y: 129, width: 373, height: 524, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-06",
        name: "PO 06 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 38, y: 38, width: 504, height: 709, rotation: 0, imageRotation: 0 },
            { id: "2", x: 549, y: 461, width: 205, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 762, y: 461, width: 205, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 974, y: 461, width: 205, height: 285, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-07",
        name: "PO 07 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 87, y: 74, width: 451, height: 633, rotation: 0, imageRotation: 0 },
            { id: "2", x: 662, y: 162, width: 327, height: 461, rotation: 0, imageRotation: 0 },
            { id: "3", x: 997, y: 74, width: 221, height: 314, rotation: 0, imageRotation: 0 },
            { id: "4", x: 997, y: 395, width: 221, height: 314, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-08",
        name: "PO 08 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 87, y: 74, width: 451, height: 633, rotation: 0, imageRotation: 0 },
            { id: "2", x: 662, y: 74, width: 221, height: 314, rotation: 0, imageRotation: 0 },
            { id: "3", x: 662, y: 395, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "4", x: 891, y: 162, width: 327, height: 461, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-09",
        name: "PO 09 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 54, y: 73, width: 454, height: 638, rotation: 0, imageRotation: 0 },
            { id: "2", x: 515, y: 73, width: 223, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 515, y: 395, width: 223, height: 315, rotation: 0, imageRotation: 0 },
            { id: "4", x: 745, y: 73, width: 453, height: 638, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-10",
        name: "PO 10 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 54, y: 73, width: 454, height: 638, rotation: 0, imageRotation: 0 },
            { id: "2", x: 515, y: 73, width: 453, height: 638, rotation: 0, imageRotation: 0 },
            { id: "3", x: 975, y: 73, width: 223, height: 315, rotation: 0, imageRotation: 0 },
            { id: "4", x: 975, y: 395, width: 223, height: 315, rotation: 0, imageRotation: 0 }
        ],
    }
];